/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    isIndex: true,
    index: "A",
    title: "Xác định thu nhập chịu thuế theo suất hợp đồng dầu khí",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[25]",
    index: "1",
    unit: "USD",
    title: "Tổng doanh thu chịu thuế TNDN trong kỳ tính thuế",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[26]",
    index: "2",
    unit: "USD",
    title: "Tổng chi phí được phép thu hồi lũy kế",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[27]",
    index: "3",
    unit: "USD",
    title: "Chi phí được trừ khi xác định thu nhập chịu thuế: [27] = [27a]+[27b]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[27a]",
    index: "3.1",
    unit: "USD",
    title: "+ Chi phí được phép thu hồi trong năm quyết toán",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[27b]",
    index: "3.2",
    unit: "USD",
    title: "+ Chi phí được trừ khác ",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[27b]",
    index: "3.2",
    unit: "USD",
    title: "+ Chi phí được trừ khác ",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[28]",
    index: "4",
    unit: "USD",
    title: "Tổng chi phí đã thu hồi luỹ kế đến hết năm quyết toán",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[29]",
    index: "5",
    unit: "USD",
    title: "Tổng chi phí còn được phép thu hồi chuyển sang kỷ sau [29]=[26]-[28]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[30]",
    index: "6",
    unit: "USD",
    title: "Thu nhập từ hoạt động dầu khí [30]=[25]-[27]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[31]",
    index: "7",
    unit: "USD",
    title: "Thu nhập khác liên quan trực tiếp đến hoạt động dầu khí",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[32]",
    index: "8",
    title: "Tổng thu nhập chịu thuế [32]=[30]+[31]",
    unit: "USD",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[33]",
    index: "9",
    title: "Thuế suất thuế TNDN hoạt động dầu khí",
    unit: "%",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    isIndex: true,
    index: "B",
    title: "Xác định thu nhập chịu thuế hoạt động khác",
  },

  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[34]",
    index: "10",
    title: "Thu nhập chịu thuế hoạt động khác",
    unit: "USD",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[35]",
    index: "11",
    title: "Thuế suất thuế TNDN hoạt động khác",
    unit: "%",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    isIndex: true,
    index: "C",
    title: "Xác định thuế TNDN phải nộp",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[36]",
    index: "12",
    title: "Số thuế TNDN phải nộp [36]=[32]x[33]+[34]x[35]",
    unit: "USD",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[37]",
    index: "13",
    title: "số thuế TNDN được miễn hoặc giảm",
    unit: "USD",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[38]",
    index: "14",
    title: "Số thuế TNDN phải nộp theo quyết toán [38]=[36]-[37]",
    unit: "USD",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[39]",
    index: "15",
    title: "Số thuế TNDN tạm tính đã kê khai trong kỳ",
    unit: "USD",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[40]",
    index: "16",
    unit: "USD",
    title:
      "Chênh lệch giữa số thuế TNDN phải nộp theo quyết toán với số đã kê khai trong kỳ tính thuế[40]=[38]-[39]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    spendId: "[41]",
    index: "17",
    title: "Tỷ giá quy đổi",
    unit: "VND/USD",
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const isDisabled = (index) => [1, 3, 7, 8, 10, 12, 14, 17, 18, 20, 22].includes(index);

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Mã số
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Đơn vị
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Giá trị
              </Td>
            </tr>

            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (2)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (3)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (5)
              </Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(index + 1) ? "#ddeff3" : "transparent",
                    fontWeight: isDisabled(index + 1) ? 800 : 400,
                  }}
                >
                  {item.index}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "left",
                    background: isDisabled(index + 1) ? "#ddeff3" : "transparent",
                    fontWeight: isDisabled(index + 1) ? 800 : 400,
                  }}
                >
                  {item.title}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(index + 1) ? "#ddeff3" : "transparent",
                    fontWeight: isDisabled(index + 1) ? 800 : 400,
                  }}
                >
                  {item.spendId}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(index + 1) ? "#ddeff3" : "transparent",
                    fontWeight: isDisabled(index + 1) ? 800 : 400,
                  }}
                >
                  {item.unit}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                    background: isDisabled(index + 1) ? "#ddeff3" : "transparent",
                    fontWeight: isDisabled(index + 1) ? 800 : 400,
                  }}
                >
                  {isDisabled(index + 1) ? (
                    ""
                  ) : (
                    <InputTable
                      id={item.id}
                      value={item.value5}
                      name="value5"
                      onChange={handleChange}
                    />
                  )}
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
